import "./TakeawayOverview.scss";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Map from "../../../../components/ticketing/map/Map";
import GradientButton from "../../../../components/buttons/gradientButton/GradientButton";
import Schedule from "../../../../components/schedule/Schedule";
import MerchantInscription from "../../ticketing/merchantInscription/MerchantInscription";

function TakeawayOverview({ org: selectedOrg }) {
  const { t } = useTranslation("takeaway");
  const navigate = useNavigate();

  return !selectedOrg?.stripeActivated ? (
    <MerchantInscription org={selectedOrg} />
  ) : (
    <div className="takeaway-overview">
      {selectedOrg && "takeawayOpen" in selectedOrg ? (
        <>
          <section className="takeaway-overview-header">
            <h1>{t("takeawayOverview")}</h1>
            <div
              className={
                selectedOrg?.takeawayOpen
                  ? "takeaway-overview-header-open"
                  : "takeaway-overview-header-close"
              }
            >
              {selectedOrg?.takeawayOpen ? t("open") : t("close")}
            </div>
          </section>

          <section className="takeaway-overview-link">
            <a
              href={`https://ticket.comitty.be/takeaway/${selectedOrg.id}`}
              target="_blank"
            >{`https://ticket.comitty.be/takeaway/${selectedOrg.id}`}</a>
          </section>

          <section
            className="takeaway-overview-picture"
            style={{
              background: `url(${selectedOrg?.coverUrl}) no-repeat center center / cover`,
            }}
          >
            <div className="takeaway-overview-picture-wrapper">
              <div className="takeaway-overview-picture-content">
                <h1 className="takeaway-overview-picture-title">{selectedOrg.organization}</h1>
                <p className="takeaway-overview-picture-description">
                  {selectedOrg?.takeawayDescription}
                </p>
              </div>
            </div>
          </section>

          <section className="takeaway-overview-details">
            <div className="takeaway-overview-details-map">
              <Map
                marker={{
                  lat: selectedOrg?.location?.latitude,
                  lng: selectedOrg?.location?.longitude,
                }}
                address={selectedOrg?.location?.address}
                setMarker={() => {}}
                displayOnly
                minHeight={window.innerWidth < 768 ? "300px" : null}
                maxHeight={window.innerWidth < 768 ? "450px" : null}
              />
            </div>
            <Schedule schedule={selectedOrg?.schedule} />
          </section>

          <section className="takeaway-overview-update">
            <GradientButton
              onPress={() =>
                navigate("/dashboard/takeaway-update-inscription", {
                  state: { selectedOrg },
                })
              }
            >
              {t("editTakeawayInfo")}
            </GradientButton>
          </section>
        </>
      ) : (
        <div className="takeaway-overview-noTakeaway">
          <h1>{t("takeawayNotEnabled")}</h1>
          <p>{t("setupTakeawayQuestion")}</p>
          <GradientButton
            onPress={() =>
              navigate("/dashboard/takeaway-update-inscription", {
                state: { selectedOrg },
              })
            }
          >
            {t("setupTakeaway")}
          </GradientButton>
        </div>
      )}
    </div>
  );
}

export default TakeawayOverview;
